import { render } from "./iconBurger.vue?vue&type=template&id=6af97f74"
import script from "./iconBurger.vue?vue&type=script&lang=js"
export * from "./iconBurger.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__